import React from "react";
import { ApiError, isErrorCode } from "../api/authApiClient";
import { constants } from "../constants";
import { useTranslation } from "react-i18next";

interface FormattedErrorProps {
  error: ApiError;
}

export const FormattedError = ({ error }: FormattedErrorProps) => {
  const { t } = useTranslation();
  if (isErrorCode(error)) {
    switch (error.code) {
      case constants.ERROR_CODES["WEAK_PASSWORD"]:
        return (
          <>
            {t("error.passwordStrength.tooWeak")}
            <ul className="mt-3 ml-4 list-outside list-disc">
              <li>
                <strong>{t("error.passwordStrength.symbols")}</strong>
                <div>{t("error.passwordStrength.random")}</div>
                <br />
                <div>{t("error.passwordStrength.pick")}</div>
                <div>{t("error.passwordStrength.example")}</div>
              </li>
            </ul>
          </>
        );
    }
  } else {
    return error;
  }
};
